import React from "react"
import styled from "styled-components"

export default function CurrentActiveUserNote({ displayText, flipLastChar }) {
  return (
    <NoteWrapper>
      {displayText.slice(0, -1)}
      {flipLastChar === true ? (
        <LastCharacter>{displayText.slice(-1)}</LastCharacter>
      ) : (
        <>{displayText.slice(-1)}</>
      )}
    </NoteWrapper>
  )
}
const NoteWrapper = styled.div`
  background: #ffe89b;
  padding: calc(100vw * (18 / 375)) 0;
  text-align: center;

  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #121212;

  @keyframes cursor-blink {
    0% {
      opacity: 0;
    }
  }
  &:after {
    content: "";
    width: 2px;
    height: calc(100vw * (16 / 375));
    background: #000000;
    display: inline-block;
    animation: cursor-blink 1s steps(2) infinite;
  }
`
const LastCharacter = styled.div`
  display: inline-block;
  background: black;
  color: white;
`
